// 9fbef606107a605d69c0edbcd8029e5d
import { renderLabel } from '../../../../../../../utils/labels/labelUtilty';

export const getAboutYouSurvey = (labels) => {
  return {
    questions: [
      {
        id: 'answer1',
        statement: renderLabel(
          labels?.lbl_profile_survey_question1,
          'lbl_profile_survey_question1'
        ),
        multiSelect: false,
        answers: [],
        optionsMap: {
          shopper1: renderLabel(
            labels?.lbl_profile_survey_question1_option1,
            'lbl_profile_survey_question1_option1'
          ),
          shopper2: renderLabel(
            labels?.lbl_profile_survey_question1_option2,
            'lbl_profile_survey_question1_option2'
          ),
          shopper3: renderLabel(
            labels?.lbl_profile_survey_question1_option3,
            'lbl_profile_survey_question1_option3'
          ),
          shopper4: renderLabel(
            labels?.lbl_profile_survey_question1_option4,
            'lbl_profile_survey_question1_option4'
          ),
        },
        options: [
          {
            id: 'shopper1',
            key: renderLabel(
              labels?.lbl_profile_survey_question1_option1,
              'lbl_profile_survey_question1_option1'
            ),
            value: renderLabel(
              labels?.lbl_profile_survey_question1_option1_en,
              'lbl_profile_survey_question1_option1_en'
            ),
            selected: false,
            dataLocator: 'moreaboutyou-question-parentbtn',
          },
          {
            id: 'shopper2',
            key: renderLabel(
              labels?.lbl_profile_survey_question1_option2,
              'lbl_profile_survey_question1_option2'
            ),
            value: renderLabel(
              labels?.lbl_profile_survey_question1_option2_en,
              'lbl_profile_survey_question1_option2_en'
            ),
            selected: false,
            dataLocator: 'moreaboutyou-question-grandparentbtn',
          },
          {
            id: 'shopper3',
            key: renderLabel(
              labels?.lbl_profile_survey_question1_option3,
              'lbl_profile_survey_question1_option3'
            ),
            value: renderLabel(
              labels?.lbl_profile_survey_question1_option3_en,
              'lbl_profile_survey_question1_option3_en'
            ),
            selected: false,
            dataLocator: 'moreaboutyou-question-giftingforothersbtn',
          },
          {
            id: 'shopper4',
            key: renderLabel(
              labels?.lbl_profile_survey_question1_option4,
              'lbl_profile_survey_question1_option4'
            ),
            value: renderLabel(
              labels?.lbl_profile_survey_question1_option4_en,
              'lbl_profile_survey_question1_option4_en'
            ),
            selected: false,
            dataLocator: 'moreaboutyou-question-prefernottoanswerbtn',
          },
        ],
      },
      {
        id: 'answer2',
        statement: renderLabel(
          labels?.lbl_profile_survey_question2,
          'lbl_profile_survey_question2'
        ),
        multiSelect: true,
        answers: [],
        optionsMap: {
          shopper1: renderLabel(
            labels?.lbl_profile_survey_question2_option1,
            'lbl_profile_survey_question2_option1'
          ),
          shopper2: renderLabel(
            labels?.lbl_profile_survey_question2_option2,
            'lbl_profile_survey_question2_option2'
          ),
          shopper3: renderLabel(
            labels?.lbl_profile_survey_question2_option3,
            'lbl_profile_survey_question2_option3'
          ),
          shopper4: renderLabel(
            labels?.lbl_profile_survey_question2_option4,
            'lbl_profile_survey_question2_option4'
          ),
          shopper5: renderLabel(
            labels?.lbl_profile_survey_question2_option5,
            'lbl_profile_survey_question2_option5'
          ),
        },
        options: [
          {
            id: 'shopper1',
            key: renderLabel(
              labels?.lbl_profile_survey_question2_option1,
              'lbl_profile_survey_question2_option1'
            ),
            value: renderLabel(
              labels?.lbl_profile_survey_question2_option1_en,
              'lbl_profile_survey_question2_option1_en'
            ),
            selected: false,
            dataLocator: 'moreaboutyou-question-girlbtn',
          },
          {
            id: 'shopper2',
            key: renderLabel(
              labels?.lbl_profile_survey_question2_option2,
              'lbl_profile_survey_question2_option2'
            ),
            value: renderLabel(
              labels?.lbl_profile_survey_question2_option2_en,
              'lbl_profile_survey_question2_option2_en'
            ),
            selected: false,
            dataLocator: 'moreaboutyou-question-boybtn',
          },
          {
            id: 'shopper3',
            key: renderLabel(
              labels?.lbl_profile_survey_question2_option3,
              'lbl_profile_survey_question2_option3'
            ),
            value: renderLabel(
              labels?.lbl_profile_survey_question2_option3_en,
              'lbl_profile_survey_question2_option3_en'
            ),
            selected: false,
            dataLocator: 'moreaboutyou-question-toddlergirlbtn',
          },
          {
            id: 'shopper4',
            key: renderLabel(
              labels?.lbl_profile_survey_question2_option4,
              'lbl_profile_survey_question2_option4'
            ),
            value: renderLabel(
              labels?.lbl_profile_survey_question2_option4_en,
              'lbl_profile_survey_question2_option4_en'
            ),
            selected: false,
            dataLocator: 'moreaboutyou-question-toddlerboybtn',
          },
          {
            id: 'shopper5',
            key: renderLabel(
              labels?.lbl_profile_survey_question2_option5,
              'lbl_profile_survey_question2_option5'
            ),
            value: renderLabel(
              labels?.lbl_profile_survey_question2_option5_en,
              'lbl_profile_survey_question2_option5_en'
            ),
            selected: false,
            dataLocator: 'moreaboutyou-question-babybtn',
          },
        ],
      },
    ],
  };
};

export default getAboutYouSurvey;
